import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/radar` is gone; this is the doorway it left behind.
 *
 * The radar and the feed were answering the same question from opposite ends.
 * Both were "where should I be", both were ordered by fit, both had a way to
 * get a room onto her calendar — and being sent from a feed of rooms to a
 * second screen *about* finding rooms was a detour, not a step. Everything
 * that was load-bearing here now lives below the cards on `/feed`: the window,
 * the curated base, the scan, and the calendars behind all of it.
 *
 * The route survives as a redirect rather than being deleted, because it was
 * linked from eight screens and any of those links could be a bookmark. A 404
 * would be the product losing a page she used yesterday; this is the page
 * having moved.
 */
export const Route = createFileRoute("/radar")({
  beforeLoad: () => {
    throw redirect({ to: "/feed", replace: true });
  },
});
